import * as React from 'react';

import classnames from 'classnames';

import {Button} from 'shells/button/button';
import {Card} from 'shells/card/card';
// @ts-expect-error - imported from .js/.jsx file
import {SchedulerIcon} from 'shells/icon/svg/scheduler-icon';

import type {GetPersonalizedDemo_personalizedDemo} from 'nutshell-graphql-types';

import {appHistory} from '../../../history';

import {OnboardingModuleCardContent} from './onboarding-module/onboarding-module-card-content';

import styles from './onboarding-schedule-card.module.css';

type Props = {
    personalizedDemo: GetPersonalizedDemo_personalizedDemo;
};

export function OnboardingScheduleCard(props: Props) {
    const {personalizedDemo} = props;

    const Illustration = () => {
        const imageContainerClassName = classnames(styles['rep-image-container'], {
            [styles['rep-image-container--chad']]: personalizedDemo.salesContactType === 'CHAD',
            [styles['rep-image-container--jared']]: personalizedDemo.salesContactType === 'JARED',
        });

        return (
            <div className={imageContainerClassName}>
                <img
                    src={personalizedDemo.salesContactImageUrl}
                    alt={personalizedDemo.salesContactName}
                />
            </div>
        );
    };

    const rightSection = (
        <Button
            variant='primary'
            size='big'
            icon={SchedulerIcon}
            onClick={() => {
                appHistory.push('/sales-demo');
            }}
        >
            Schedule session
        </Button>
    );

    return (
        <Card hasBorder={true} borderRadius={8} fitHeight={true}>
            <OnboardingModuleCardContent
                illustration={<Illustration />}
                title='Meet with a CRM Pro'
                description={`If you have any questions or specific needs, feel free to book a session with ${personalizedDemo.salesContactShortName}!`}
                rightSection={rightSection}
            />
        </Card>
    );
}
